import {
  assignmentSourceCheckFailedMessage,
  type AssignmentSourceProbeResult,
} from '@gonfalon/experiments/useAssignmentSourceProbe';
import type { HealthCheckStatus } from '@gonfalon/health-check/types';

export const incompleteAssignmentSourceMessage = 'Select an assignment source and experiment ID.';
export const checkingAssignmentSourceMessage = 'Checking assignment source size...';
export const assignmentSourceWithinLimitsMessage = 'Assignment source size is within limits.';
export const assignmentSourceSizeWarningFallbackMessage = 'Iteration analysis will take longer than usual.';
export const assignmentSourceBlockedFallbackMessage =
  'The assignment source is too large to start this experiment. Narrow the time window or reduce the size of the source.';
export const saveToCheckAssignmentSourceMessage = 'Save or start the experiment to check assignment source size.';
const assignmentSourceCheckFailedRetryMessage = `${assignmentSourceCheckFailedMessage} Try again.`;

export type AssignmentSourceHealthCheckItem = {
  status: HealthCheckStatus;
  message: string;
};

export function mapAssignmentSourceProbeToHealthCheck(
  probe: AssignmentSourceProbeResult,
): AssignmentSourceHealthCheckItem {
  if (probe.status === 'pending') {
    return { status: 'loading', message: checkingAssignmentSourceMessage };
  }

  if (probe.status === 'unchecked') {
    return { status: 'waiting', message: saveToCheckAssignmentSourceMessage };
  }

  if (probe.status === 'ok') {
    return { status: 'pass', message: assignmentSourceWithinLimitsMessage };
  }

  if (probe.status === 'warn') {
    return {
      status: 'warning',
      message: probe.warningMessage ?? assignmentSourceSizeWarningFallbackMessage,
    };
  }

  if (probe.status === 'blocked') {
    return {
      status: 'fail',
      message: probe.blockMessage ?? assignmentSourceBlockedFallbackMessage,
    };
  }

  if (probe.status === 'error') {
    return {
      status: 'error',
      message:
        probe.errorMessage && probe.errorMessage !== assignmentSourceCheckFailedMessage
          ? probe.errorMessage
          : assignmentSourceCheckFailedRetryMessage,
    };
  }

  return { status: 'waiting', message: incompleteAssignmentSourceMessage };
}
